import React from 'react';
import 'chart.js/auto';
import { Pie } from 'react-chartjs-2'

//import classes from './Card.module.css';

const PieChart = (props) => {

    //ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement);

    return (
        <div>
            <Pie key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
                />
            </div>
          
    );
};

export default PieChart;
